export const FILTER_TYPE = {
  INSTITUTION: 'institution_ids',
  SCHEDULED_DATE: 'scheduled_date',
  PATIENT_NAME: 'patient_name',
  ORDER_GROUP: 'order_group',
  PATIENT_ID: 'patient_id',
  VISIT_ID: 'visit_id',
};
